import lazyLoading from "./lazyLoading";

export default {
  name: "trainings",
  meta: {
    icon: "fa-graduation-cap",
    expanded: false,
    label: "Formations",
    permissions: "list trainings"
  },

  children: [
    {
      name: "list-campus",
      path: "/admin/campus/list",
      meta: {
        title: "Liste des campus",
        label: "Campus",
        isAdminStaff: true
      },
      component: lazyLoading("trainings/CampusList")
    },
    {
      name: "list-schools",
      path: "/admin/schools/list",
      meta: {
        title: "Liste des écoles",
        label: "Ecoles",
        isAdminStaff: true
      },
      component: lazyLoading("trainings/SchoolList")
    },
    {
      name: "list-trainings",
      path: "/admin/trainings/list",
      meta: {
        title: "Liste des formations",
        label: "Formations",
        //isAdminStaff: true,
        permissions: "list trainings"
      },
      component: lazyLoading("trainings/TrainingList")
    },
    {
      name: "list-dates",
      path: "/admin/trainings/dates",
      meta: {
        title: "Calendrier",
        label: "Calendrier",
        permissions: "list training dates and capacity"
      },
      component: lazyLoading("trainings/TrainingDateList")
    },
    {
      name: "list-capacities",
      path: "/admin/trainings/capacities",
      meta: {
        title: "Capacités",
        label: "Capacités",
        permissions: "list training dates and capacity"
      },
      component: lazyLoading("trainings/TrainingCapacityList")
    },
  ]
};
